/**
 * The one spinner. Replaces six copies of a 20-line Tailwind ring plus four
 * copies of a 40-line inline SVG (three of which used `class=`, not
 * `className=`, and so rendered unstyled while warning in the console).
 */
const Spinner = ({ size = "lg", className = "" }) => {
  const box = size === "sm" ? "h-8 w-8 border-2" : "h-20 w-20 border-4";

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        role="status"
        className={`${box} inline-block animate-spin rounded-full border-solid border-current border-e-transparent align-[-0.125em] text-brand motion-reduce:animate-[spin_1.5s_linear_infinite]`}
      >
        <span className="sr-only">در حال بارگذاری...</span>
      </div>
    </div>
  );
};

/** Full-height variant used while a page's primary request is in flight. */
export const PageSpinner = () => <Spinner className="h-[40rem]" />;

export default Spinner;
